import {inject, Injectable} from "@angular/core";
import Keycloak from "keycloak-js";
import {SettingsDataService} from "./settings-data.service";
import {map, Observable, of} from "rxjs";

@Injectable({providedIn: 'root'})
export class ConfigWriteUserService {
    private readonly keycloak = inject(Keycloak);
    private readonly settingsDataService = inject(SettingsDataService);

    readonly isAuthorized = this.keycloak.hasRealmRole('portal_config_write');

    isAllowedToEditApplicationSettings(applicationName: string | null | undefined): Observable<boolean> {
        if (!this.isAuthorized || !applicationName) {
            return of(false);
        }

        return this.settingsDataService.findAllByApplicationName('ConfigurationServiceUI').pipe(
            map((response: any[]) => {
                const setting = response?.[0];
                if (!setting?.applicationSettings) {
                    return false;
                }

                try {
                    const applicationSettings = JSON.parse(setting.applicationSettings);
                    const editableApplicationSettings: string[] = applicationSettings.editableApplicationSettings ?? [];
                    return editableApplicationSettings.includes(applicationName);
                } catch {
                    return false;
                }
            })
        );
    }
}